import { stopAutoDisconnectionAction } from "../actionCreators/ajaxActionCreator";

export function stopAutoDisconnection() {
  return dispatch => {
    dispatch(stopAutoDisconnectionAction());
  };
}
